import React from 'react';

const AD = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_214"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_214)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#FFE100"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H7V15H0V0Z"
        fill="#0006AB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 0H21V15H14V0Z"
        fill="#D20636"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.936 9.935C12.55 9.748 13 9.177 13 8.5V5.5C13 4.665 12.328 4 11.5 4H9.5C8.674 4 8 4.67 8 5.5V8.5C8 9.182 8.448 9.75 9.064 9.936C9.25 10.556 9.822 11 10.5 11C11.182 11 11.75 10.55 11.936 9.935Z"
        fill="#C8B47C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 5H10V6.5H9V5ZM11 7H12V8.5H11V7Z"
        fill="#D20636"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 5H12V6.5H11V5ZM9 7H10V8.5H9V7Z"
        fill="#FFE100"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default AD;
